import { MembershipPlanId } from '../../commonv3/types/membershipPlans';
import { MainV3ApiBase } from './base';
import { CouponIndexView } from '../types/coupons';

export const CouponApis = {
  show(couponCode: string, email: string, membershipPlanId: MembershipPlanId): Promise<CouponIndexView> {
    return MainV3ApiBase.appendPath('coupons').withId(couponCode).get({ email, membership_plan_id: membershipPlanId });
  },
  default_coupon(): Promise<CouponIndexView> {
    return MainV3ApiBase.appendPath('coupons/default_coupon').get();
  },
};
